import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45d49a81"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-lg" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-20 fw-bold text-center w-100" }, "ポイント履歴", -1))
const _hoisted_4 = { class: "modal-body d-flex justify-content-center" }
const _hoisted_5 = { class: "table table-borderless t-responsive" }
const _hoisted_6 = { class: "align-middle text-center t-head py-3 fw-bold mx-0 position-sticky top-0" }
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = { class: "col-2 text-end" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1))
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { id: "table-body row" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_15 = { class: "text-start" }
const _hoisted_16 = {
  key: 0,
  class: "text-center fw-bold"
}
const _hoisted_17 = { class: "modal-footer d-flex justify-content-center" }

import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { onMounted, ref, watchEffect, computed } from 'vue'
import { useStore } from 'vuex'
import { POINT_STORE } from '@/store/constants'
import { numberWithCommas } from '@/constants/common.ts'
import dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const pointHistory = computed(() => store.getters[POINT_STORE.GETTERS.POINT_HISTORIES])
const page = computed(() => store.getters[POINT_STORE.GETTERS.PAGE])

const getData = (page: number) => {
  store.dispatch(POINT_STORE.ACTIONS.SET_POINT_HISTORIES, { params: { ...(page && { page }) } })
}
// 2022/10/12 VietNC point histories UAT#4607(Ph2-R20221021)
// onMounted(() => {
//   store.dispatch(POINT_STORE.ACTIONS.SET_POINT_HISTORIES, { change: true, params: { page: 1 } })
// })

const resetScroll = () => {
  document.querySelector('.t-table').scrollTop = 0
}

const scrollData = (e) => {
  if (e.target.scrollTop + e.target.offsetHeight > e.target.scrollHeight) {
    if (page.value >= pointHistory.value.total_pages) return
    store.dispatch(POINT_STORE.ACTIONS.SET_PAGE)
    if (page.value !== 1) getData(page.value)
  }
}
const convertTextPoint = (text: string, community_operating_name: string) => {
  if (text === 'point_from_mynavi') return translate('SJ10textTable1')
  if (text === 'point_from_community') return community_operating_name + translate('SJ10textTable2')
  if (text === 'use_point') return ''
  if (text === 'point_expired') return translate('有効期限切れ')
}

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: "pointHistoryModal",
    tabindex: "-1",
    "aria-labelledby": "pointHistoryModal",
    "aria-hidden": "true",
    ref: (_value, _refs) => {
      _refs['modalTest'] = _value
    }
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", { class: "modal-header" }, [
          _hoisted_3,
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: resetScroll
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "table-responsive mx-4 t-table",
            onScroll: scrollData
          }, [
            _createElementVNode("table", _hoisted_5, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_6, [
                  _createElementVNode("th", _hoisted_7, _toDisplayString(_unref(translate)('SJ10updated')), 1),
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_unref(translate)('SJ10earnPointed')), 1),
                  _hoisted_9,
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_unref(translate)('SJ10remarks')), 1)
                ])
              ]),
              _createElementVNode("tbody", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pointHistory).data, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: _normalizeClass(["align-middle py-3 mx-0 fs-75", [index % 2 === 0 ? '' : 't-body']]),
                    key: index
                  }, [
                    _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(dayjs)(item?.created_at).format('YYYY/MM/DD HH:mm:ss')), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(numberWithCommas)(item?.point)) + "pt", 1),
                    _hoisted_14,
                    _createElementVNode("td", _hoisted_15, _toDisplayString(convertTextPoint(item?.text, item?.community_name)), 1)
                  ], 2))
                }), 128))
              ])
            ]),
            (_unref(pointHistory).data?.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(translate)('CC10noData')), 1))
              : _createCommentVNode("", true)
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(Button, {
            title: _unref(translate)('close'),
            type: 'secondary',
            class: _normalizeClass('fw-bold'),
            "data-bs-dismiss": 'modal',
            onClick: resetScroll
          }, null, 8, ["title"])
        ])
      ], 512), [
        [_directive_click_outside, resetScroll]
      ])
    ])
  ], 512))
}
}

})